module.exports = __webpack_public_path__ + "citroen.152fdff66df3318c38ae.png";